import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './read-more.scss';

export function ReadMore({
  containerClasses,
  summaryClasses,
  baseDescriptionCopy,
  children,
  style,
  bottom,
  paddingBottom,
}) {
  return (
    <div className={classnames('read-more-container', paddingBottom, containerClasses)} style={style}>
      {baseDescriptionCopy}
      <details className="pos-r">
        <summary className={classnames('pos-a', summaryClasses)} style={{ bottom }}>
          <span className="is-closed">Read More</span>
          <span className="is-open">Read Less</span>
        </summary>
        <div className="read-more-description flex-shrink-0">{children}</div>
      </details>
    </div>
  );
}

ReadMore.propTypes = {
  containerClasses: PropTypes.string,
  summaryClasses: PropTypes.string,
  baseDescriptionCopy: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  style: PropTypes.shape({}),
  bottom: PropTypes.string,
  paddingBottom: PropTypes.string,
};

ReadMore.defaultProps = {
  containerClasses: null,
  summaryClasses: null,
  baseDescriptionCopy: null,
  style: null,
  bottom: '-2rem',
  paddingBottom: 'pb-2',
};
